<script setup>
defineProps({
  label: {type: String, required: true},
});
</script>

<template>
  <div
    data-testid="customer-chat-typing-indicator"
    class="inline-flex items-center gap-2 text-xs text-stone-500"
    role="status"
    aria-live="polite"
  >
    <span class="sr-only">{{ label }}</span>
    <span aria-hidden="true" class="inline-flex items-center gap-1 rounded-full border border-stone-200 bg-white px-3 py-2">
      <span class="cw-chat-typing-dot" />
      <span class="cw-chat-typing-dot [animation-delay:150ms]" />
      <span class="cw-chat-typing-dot [animation-delay:300ms]" />
    </span>
    <span>{{ label }}</span>
  </div>
</template>

<style scoped>
.cw-chat-typing-dot {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 9999px;
  background: rgb(120 113 108);
  animation: cw-chat-typing-bounce 900ms infinite ease-in-out;
}

@keyframes cw-chat-typing-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.45; }
  30% { transform: translateY(-0.2rem); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .cw-chat-typing-dot { animation: none; opacity: 0.8; }
}
</style>
